<a [routerLink]="[]" (click)="preventDefault($event)" class="tip">
    <i class="fa fa-question-circle" aria-hidden="true"></i>
    <span>
        <pre> search Guidelines:
    
        Applicable on search field - Extension, FileName, Path, and Hash.
        
        Search Instructions
        To perform a wildcard search, we need to use '*' on the pre and post case of the search query.
        
        let's suppose we have text- 'abcdef'
        Enter 'ab' to search anywhere in the text.
        Enter 'ab*' to search in content that first character contains 'ab'
        Enter '*ef' to search in content that the last character contains 'ef' 
        Enter 'ab*ef' to search in content that is unknown character between 'ab' and 'ef'
        Enter 'ab*d*f to search for missing character.
        
        For FileSize field
        Enter number range to search file size that lies in this range.
        To search an exact number, use the same value in both the min and max fields.
        
        For Date field - Create, Modify, and Access date.
        Enter a date range to search date that lies in this range.
        To search an exact number, use the same value in both the "oldest" and "newest" fields.</pre>
    </span>
</a>
